import { SVG } from '@svgdotjs/svg.js';
import '@svgdotjs/svg.filter.js';
// commit test
import {
    stickerConfigurations,
    productConfigurations
} from './config.js';

import {
    cardState,
    createCarouselTray,
    SKU,
    handleSVGActions, undo, redo, undoStacks, redoStacks, uniqueId

} from './script.js';

import {
    setupDraggable,
    makeDraggable
} from './eventListeners.js';
import wrapSvgText from 'wrap-svg-text';

import {
    generateUniqueId,
    updateArrowVisibility
} from './utils.js';

import {
    makeOverlayDraggable,
    makeItemResizable,
    removeBlueBorder,
    showItemOverlay,
    createOverlayControlBar,
    positionOverlayControlBar,
    hideOverlay,
    resetOverlayTimeout
} from './controls.js';

import {
    generateContentUniversal
} from './ai.js';

import {
    attachItemListeners

} from './eventListeners.js';

import {
    GOOGLE_API_KEY
} from './constants.js';

export let draw = {};
export let trayCreated = false;

let zIndexCounter = 2;


/**
 * Updates the template of the page with the given configurations.
 * @param {string} page - The page to be updated.
 */
export function updatePageTemplate(page) {


    // Check if both SKU and productConfigurations are defined.
    if (!SKU || !productConfigurations) {
        console.warn("Either SKU or productConfigurations is not defined");
        return;
    }

    // Fetch the product and page configurations.
    const configForProduct = productConfigurations[SKU];
    const configForPage = configForProduct && configForProduct[page];

    // Execute various setup and update functions.
    updateCurrentPageDisplay(page);
    clearExistingDrawing(page);
    setPageSize(page, configForPage);
    logConfigurationDetails(SKU, page, configForProduct, configForPage);
    initializeCardState(SKU, page);

    setupCanvasElements(page, configForProduct, configForPage, SKU);
    renderDesignAdditions(configForPage);
    handleTabConfiguration(SKU, page);
    createAddVideoButton(page, configForProduct, configForPage, SKU);

    // Update the visibility of arrows based on the current state.
    updateArrowVisibility();


}


export function updateSVGSizeType() {
    const cardType = SKU;
    const sizeConfig = page_size[SKU];

    // Check if sizeConfig exists
    if (sizeConfig) {
        // Extract width and height from the configuration
        const [width, height] = sizeConfig.split('x').map(dim => parseInt(dim, 10));

        // Update the sizes
        draw['front_cover'].size(width, height);
        draw['inside_right'].size(width, height);
        draw['inside_left'].size(width, height);
    } else {
        console.error(`Size configuration not found for SKU: ${SKU}`);
    }
}
export function setupDefaultImage(drawInstance, defaultConfig) {
    if (defaultConfig && defaultConfig.image) {
        // Loop through each image in the array
        defaultConfig.image.forEach(img => {
            // Calculate the top-left corner based on the center coordinates
            const topLeftX = img.x - (img.w / 2);
            const topLeftY = img.y - (img.h / 2);

            const imageElement = drawInstance.image(img.url)
                .size(img.w, img.h)
                .move(img.x, img.y)
                .rotate(img.r);

            imageElement.node.style.zIndex = '1'; // Ensure the image is above the background but beneath the stickers.
            imageElement.node.style.cursor = 'none'; // Set cursor to 'none' to hide it when hovering over this image.
            imageElement.node.style.pointerEvents = 'none';
            if (img.id) {
                imageElement.node.id = img.id;
            }
        });
    }
}



function updateCurrentPageDisplay(page) {
    document.getElementById('currentPage').textContent = `Current Page: ${page}`;
}

function clearExistingDrawing(page) {
    if (draw[page]) {
        draw[page].clear();
    }
}

function logConfigurationDetails(productData, page, configForProduct, configForPage) {
    console.log("product_data:", productData);
    console.log("page:", page);
    console.log("Config for product_data:", configForProduct);
    console.log("Config for page:", configForPage);
    if (configForPage && configForPage['page_size']) {
        console.log("Page size:", configForPage['page_size']);
    }
}
/**
 * This function initializes the card state for the given SKU and page.
 * @param {string} SKU - The SKU of the product.
 * @param {string} page - The page to be initialized.
 */
function initializeCardState(SKU, page) {
    // Check if both SKU and productConfigurations are defined.
    if (!SKU || !productConfigurations) {
        console.warn("Either SKU or productConfigurations is not defined");
        return;
    }

    // Fetch the product and page configurations.
    const configForProduct = productConfigurations[SKU];
    const configForPage = configForProduct && configForProduct[page];

    // Initialize the card state with the configurations.
    cardState[SKU] = cardState[SKU] || {};
    cardState[SKU][page] = configForPage;

    console.log(`Card state for SKU: ${SKU} and page: ${page} has been initialized.`);
}/**
 * Removes the existing SVG containers.
 */
export function destroyDraw() {
    console.log("Calling destroyDraw...");

    if (!productConfigurations || !SKU) {
        console.warn("Either productConfigurations or SKU is not defined");
        return;
    }

    if (productConfigurations && productConfigurations[SKU]) {
        Object.keys(productConfigurations[SKU]).forEach(page => {
            const containerId = `${page}-container`;
            const container = document.getElementById(containerId);
            if (container) {
                console.log(`Removing container with ID: ${containerId}`);
                container.remove();
            } else {
                console.warn(`Container with ID ${containerId} not found!`);
            }
        });
    } else {
        console.warn(`Product type ${SKU} is not defined`);
    }
}

/**
 * Initialize the drawing elements for each page in the product configurations.
 * It creates SVG elements and attaches them to the corresponding containers.
 */
export function initializeDraw() {
    if (!productConfigurations || !SKU) {
        console.warn("Either productConfigurations or SKU is not defined");
        return;
    }

    createCanvasStructure(SKU);

    if (productConfigurations && productConfigurations[SKU]) {
        Object.keys(productConfigurations[SKU]).forEach(page => {
            const containerId = `${page}-container`;
            let container = document.getElementById(containerId);

            if (!container) {
                container = document.createElement('div');
                container.id = containerId;
                container.style.position = 'relative';
                // Add box shadow for realistic card effect

                document.getElementById('canvas-container').appendChild(container);
            }


            const { page_size = '100x100' } = productConfigurations[SKU][page];
            const [width, height] = page_size.split('x').map(Number);

            // Create SVG with viewBox and preserveAspectRatio
            draw[page] = SVG()
                .addTo(container)
                .size(width, height)
                .viewbox(0, 0, width, height)
                .attr('preserveAspectRatio', 'xMidYMid meet')
                .attr('id', `${page}-svg`); // This line adds an ID to the SVG

        });
    } else {
        console.warn(`Product type ${SKU} is not defined`);
    }

    console.log("Draw instances:", draw);
}
function setPageSize(page, configForPage) {
    // Initialization checks omitted for brevity

    let maxHeight = 0;
    let pageWidth = 0;
    let pageHeight = 0;
    let initialHeight = 0;
    let loadingTextExists = false; // Flag to track if the loading text already exists
    const totalPages = Object.keys(productConfigurations[SKU]).length; // Example, adjust accordingly

    // Set the ssize of the current SVG if page_size is available
    if (configForPage) {
        const { page_size = null } = configForPage;
        if (page_size) {
            [pageWidth, pageHeight] = page_size.split('x').map(Number);
            draw[page].size(pageWidth, pageHeight);
        }
    }

    // Insert loading text at the beginning
    if (page === 'front_cover') { // Or however you determine the first page
        insertLoadingText();
        setTimeout(checkHeightAndUpdate, 2000); // Ensure animation completion
    }

    // Function to check maxHeight after animation and additional delay
    function checkHeightAndUpdate() {
        maxHeight = draw[page].node.getBoundingClientRect().height;
        if (maxHeight === 0 && pageWidth > 0 && pageHeight > 0) {
            maxHeight = pageHeight;
        }
        initialHeight = document.getElementById('canvas-container').getBoundingClientRect().height;
        updateContainerHeight(maxHeight);
        if (Object.keys(draw).length === totalPages) {
            removeLoadingText(); // Removal of loading text placed here, assuming this is part of the animation completion
            console.log('All pages have been processed, proceed with the animation or other final steps.');
            // Insert any additional final steps or animations here
        }
    }



    // Update container height
    function updateContainerHeight(height) {
        const container = document.getElementById('canvas-container');
        if (container) {
            container.style.transition = 'height 0.5s ease-in-out';
            container.style.height = `${height}px`;
            animateOpacity(container, height);
        } else {
            console.error('Canvas container not found');
        }
    }

    // Animate opacity of the loading text based on container height
    function animateOpacity(container, targetHeight) {
        function update() {
            const currentHeight = container.getBoundingClientRect().height;
            const progress = (currentHeight - initialHeight) / (targetHeight - initialHeight);
            const opacity = 1 - progress; // Inverse relationship: as progress increases, opacity decreases
            setLoadingTextOpacity(Math.max(0, opacity)); // Ensure opacity doesn't go below 0

            if (currentHeight >= 220) {
                removeLoadingText(); // Ensure the loading text is removed once target height is reached
            } else {
                requestAnimationFrame(update); // Continue the loop until targetHeight is reached
            }
        }
        requestAnimationFrame(update);
    }

    // Set loading text opacity
    function setLoadingTextOpacity(opacity) {
        const loadingText = document.getElementById('loading_Text');
        if (loadingText) {
            loadingText.style.opacity = opacity.toString();
        }
    }

    // Remove loading text after fade-out
    function removeLoadingText() {
        const loadingText = document.getElementById('loading_Text');
        if (loadingText) {
            loadingText.remove();
            loadingTextExists = false; // Reset the flag as the loading text is removed
        }
    }

    // Insert loading text function
    function insertLoadingText() {
        if (!loadingTextExists) { // Only insert if loading text does not already exist
            const canvasWrapper = document.getElementById('canvas-wrapper');
            if (canvasWrapper) {
                const loadingText = document.createElement('div');
                loadingText.id = 'loading_Text';
                loadingTextExists = true; // Set the flag as the loading text is created

                // Add inline styling for the loading text
                loadingText.style = `
                    color: black;
                    font-size: 16px;
                    text-align: center;
                    padding: 10px;
                    position: absolute;
                    bottom: 0;
                    width: 100%;
                `;

                // Set the loading text content
                loadingText.textContent = 'Loading...';

                // Append the loadingText as the last child of the canvasWrapper
                canvasWrapper.appendChild(loadingText);
            }
        }
    }
}


function createCanvasStructure(productData) {

    // Fetch product configuration using productData
    const configForProduct = productConfigurations[productData];

    if (!configForProduct) {
        console.warn(`Configurations not found for product: ${productData}`);
        return;
    }

    // Get the existing canvas structure
    const canvasWrapper = document.getElementById('canvas-wrapper');
    if (!canvasWrapper) {
        console.warn("No canvas-wrapper found in the DOM");
        return;
    }

    // Clear the contents of the existing canvasWrapper
    while (canvasWrapper.firstChild) {
        canvasWrapper.firstChild.remove();
    }

    // Create left fade
    const leftFade = document.createElement('div');
    leftFade.id = 'leftFade';
    leftFade.className = 'carousel-fade';
    canvasWrapper.appendChild(leftFade);

    // Create left arrow button
    const leftArrow = document.createElement('button');
    leftArrow.id = 'leftArrow';
    leftArrow.innerText = '←';
    canvasWrapper.appendChild(leftArrow);

    // Create canvas container
    const canvasContainer = document.createElement('div');
    canvasContainer.id = 'canvas-container';
    canvasWrapper.appendChild(canvasContainer);

    // Iterate over each page in the product configuration
    for (const page in configForProduct) {
        // Create container for each page
        const pageContainer = document.createElement('div');
        pageContainer.id = `${page}-container`;
        pageContainer.style.position = 'relative';

        // Create name overlay for each page
        const pageNameOverlay = document.createElement('div');
        pageNameOverlay.className = 'page-name-overlay';
        pageNameOverlay.innerText = page.replace('_', ' ').charAt(0).toUpperCase() + page.replace('_', ' ').slice(1);

        pageContainer.appendChild(pageNameOverlay);

        // Check for specific features like 3D mode
        if (configForProduct[page].mode === 'card' && page === "feature_3d") {
            const carouselItem = document.createElement('div');
            carouselItem.className = 'carousel-item';

            const loadingScreen = document.createElement('div');
            loadingScreen.id = 'loadingScreen';

            const loadingText = document.createElement('div');
            loadingText.id = 'loadingText';
            loadingText.innerText = 'Loading Preview';

            const spinner = document.createElement('div');
            spinner.id = 'spinner';

            loadingScreen.appendChild(loadingText);
            loadingScreen.appendChild(spinner);

            const threeJSContainer = document.createElement('div');
            threeJSContainer.id = 'threeJSContainer';
            threeJSContainer.style.width = '100%';
            threeJSContainer.style.position = 'relative';
            threeJSContainer.style.height = '460px';

            carouselItem.appendChild(loadingScreen);
            carouselItem.appendChild(threeJSContainer);

            pageContainer.appendChild(carouselItem);
        }

        canvasContainer.appendChild(pageContainer);
    }

    // Append right fade and right arrow to the canvasWrapper
    const rightFade = document.createElement('div');
    rightFade.id = 'rightFade';
    rightFade.className = 'carousel-fade';
    canvasWrapper.appendChild(rightFade);

    const rightArrow = document.createElement('button');
    rightArrow.id = 'rightArrow';
    rightArrow.innerText = '→';
    canvasWrapper.appendChild(rightArrow);

    console.log(canvasWrapper);
}


function renderDesignAdditions(configForPage) {
    const designAdditionsDiv = document.getElementById('design_additions');
    designAdditionsDiv.innerHTML = ''; // Clear the existing content


    // Check if AI background is available for the current configuration
    if (configForPage && configForPage.ai_background) {
        //      createSectionWithBackgroundOptions();
    }

    if (configForPage && configForPage.stickers) {
        // Logic to handle stickers
        // For instance, you might want to create a section with sticker options
        // createSection('Stickers', 'sticker-container');
    }

    if (configForPage && configForPage.frames) {
        // Logic to handle frames
        // As an example, you can create a section with frame options
        // createSection('Frames', 'frame-container');
    }

    console.log(designAdditionsDiv.innerHTML);
}

function createSectionWithBackgroundOptions() {
    createSection('Background', 'background-container');

    const backgroundContainer = document.getElementById('background-container');
    const backgroundSelector = document.createElement('select');
    backgroundSelector.id = 'backgroundSelector';
    backgroundSelector.onchange = function () {
        handleBackgroundChange(this);
    };
    backgroundSelector.innerHTML = `
        <option value="default">Default</option>
        <option value="ai">AI Generated</option>
    `;
    backgroundContainer.appendChild(backgroundSelector);

    createAIInputOptions(backgroundContainer);
}

function createAIInputOptions(parentElement) {
    const aiInputBox = document.createElement('div');
    aiInputBox.className = 'background-box ai-background-box';

    const aiInputLabel = document.createElement('label');
    aiInputLabel.setAttribute('for', 'customBackground');
    aiInputLabel.textContent = 'Describe your desired background:';

    const aiInput = document.createElement('input');
    aiInput.id = 'customBackground';
    aiInput.placeholder = 'e.g., Sunset over a beach';

    const generateButton = document.createElement('button');
    generateButton.id = 'generateButton';
    generateButton.textContent = 'Generate';
    generateButton.onclick = function () {
        generateContentUniversal('background', 0, null, null);

    };

    aiInputBox.appendChild(aiInputLabel);
    aiInputBox.appendChild(aiInput);
    aiInputBox.appendChild(generateButton);
    parentElement.appendChild(aiInputBox);
}

function createSection(title, containerId) {
    const section = document.createElement('div');
    // For adding titles to sections, uncomment the following line
    // section.innerHTML = `<h3>${title}</h3>
    const container = document.createElement('div');
    container.id = containerId;
    section.appendChild(container);
    document.getElementById('design_additions').appendChild(section);
}
/**
 * Sets up the canvas elements based on the configurations provided.
 * @param {string} page - The current page.
 * @param {Object} configForProduct - The configuration data for the product.
 * @param {Object} configForPage - The configuration data for the page.
 * @param {string} productData - The SKU or product data.
 */
function setupCanvasElements(page, configForProduct, configForPage, productData) {
    console.log(configForProduct);
    console.log(configForPage);

    // Check if the productData and page exist in cardState before accessing their properties
    if (cardState[productData] && cardState[productData][page]) {
        const currentState = cardState[productData][page];


        if (configForPage && 'stickers' in configForPage) {
            setupItemsOnCanvas(draw[page], currentState, configForPage, productData, 'sticker');
        }

        // Only proceed with background and text setup if configForPage exists
        if (configForPage && (configForPage.text || configForPage.background)) {
            // Fallback for missing background configuration
            configForPage.background = configForPage.background || '#ffffff';
            setupBackgroundAndText(draw[page], configForPage, currentState, page);
        }

        // Determine if user photo exists and has an index attribute
        const hasUserPhotoWithIndex = Array.isArray(configForPage.user_photo) && configForPage.user_photo.length > 0 && configForPage.user_photo.some(photo => photo.index !== undefined);

        if (hasUserPhotoWithIndex) {
            // Render user photo first when it has an index attribute
            setupItemsOnCanvas(draw[page], currentState, configForPage, productData, 'user_photo');

            // Check and render default image if available
            if (configForPage.image) {
                setupDefaultImage(draw[page], configForPage);
            }
        } else {
            // Check and render default image first if available, when there's no user photo with an index
            if (configForPage.image) {
                setupDefaultImage(draw[page], configForPage);
            }

            // Then, check and render user photo if available (but without index or not present)
            if (Array.isArray(configForPage.user_photo) && configForPage.user_photo.length > 0) {
                setupItemsOnCanvas(draw[page], currentState, configForPage, productData, 'user_photo');
            }
        }


        // Conditionally set up name, default image, stickers, user photos, and frames
        // Each setup is executed only if the corresponding configuration is provided
        if (configForPage && configForPage.name) {
            setupName(draw[page], configForPage, currentState, page);
        }


        if (configForPage && Array.isArray(configForPage.frames) && configForPage.frames.length > 0) {
            setupFrames(draw[page], productData, page);
        }

        // Check for SVG elements and make them editable if applicable
        if (draw[page] && draw[page].node) {
            const svgElements = draw[page].node.querySelectorAll('text, tspan, image');
            //   if (svgElements && svgElements.length > 0) {
            showcaseEditableSVGElements(svgElements);
            // }
        }
    } else {
        console.error(`Missing cardState for productData: ${productData} and page: ${page}`);
    }
}

function setupFrames(drawPage, productData, page) {
    const savedFrame = cardState[productData] && cardState[productData][page] && cardState[productData][page].frame;
    if (savedFrame) {
        drawPage.image(savedFrame).size(300, 500); // Assuming a fixed size; adjust as necessary
    }
}












// To remove the effect
//removeAcrylicEffect('acrylicOverlay');





function setupSpotifyTab(currentTab) {
    const containerDiv = document.querySelector('.editor-container');

    // Clear existing content in the container
    containerDiv.innerHTML = '';


    const style = document.createElement('style');
    style.type = 'text/css';
    style.innerHTML = `
        .modal {
            display: none; 
            position: fixed; 
            z-index: 1; 
            left: 0;
            top: 0;
            width: 100%; 
            height: 100%; 
            overflow: auto; 
            background-color: rgba(0,0,0,0.4);
        }

        .music_modal-content {
            background-color: #fefefe;
            margin: 15% auto; 
            padding: 20px;
            border: 1px solid #888;
            width: 80%; 
        }

        .close {
            color: #aaa;
            float: right;
            font-size: 28px;
            font-weight: bold;
        }

        .close:hover,
        .close:focus {
            color: black;
            text-decoration: none;
            cursor: pointer;
        }

        .results-container {
            margin-top: 20px;
            max-height: 300px; /* Fixed max height with scroll */
            overflow-y: auto;
        }
        
        .result-item {
            display: flex;
            align-items: center;
            border-bottom: 1px solid #ddd;
            padding: 10px;
            cursor: pointer;
        }
        
        .result-item:hover {
            background-color: #f1f1f1;
        }
        
        .result-item img {
            width: 50px;
            height: 50px;
            margin-right: 10px;
        }
        
        .result-item .details {
            display: flex;
            flex-direction: column;
        }

        .selected-track {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-bottom: 10px;
        }
    
        .track-image {
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    
        .track-details {
            text-align: center;
        }
    
        .close-button {
            position: absolute;
            top: 0;
            right: 0;
            background-color: green;
            color: white;
            border: none;
            padding: 1px 6px;
            border-radius: 50%;
            cursor: pointer;
            transform: translate(38%, 2%);
        }
    
        .close-button:hover {
            background-color: darkgreen;
        }
    
        .upload-photo-button {
            background-color: green;
            color: white;
            border: none;
            padding: 10px 20px;
            border-radius: 5px;
            cursor: pointer;
            margin-top: 10px;
        }
    
        .upload-photo-button:hover {
            background-color: darkgreen;
        }
        
    `;
    document.head.appendChild(style);

    // Create and append the search input
    const searchInput = document.createElement('input');
    searchInput.type = 'text';
    searchInput.id = 'searchQuery';
    searchInput.placeholder = 'Type an artist, album, or song...';
    containerDiv.appendChild(searchInput);

    // Create and append the search button
    const searchButton = document.createElement('button');
    searchButton.id = 'searchSpotify';
    searchButton.textContent = 'Search';
    containerDiv.appendChild(searchButton);

    // Attach event listener to the search button for search functionality
    searchButton.addEventListener('click', function () {
        event.preventDefault();
        event.stopPropagation();
        performSearch();
    });

    function resetSearchInterface() {
        containerDiv.innerHTML = '';
        containerDiv.appendChild(searchInput);
        containerDiv.appendChild(searchButton);
    }
    // Function to handle search and display results
    function performSearch() {
        const searchQuery = document.getElementById('searchQuery').value;
        const serverSearchEndpoint = 'https://i.expresscreations.co.uk/spotify/search';
        fetch(serverSearchEndpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ searchQuery, searchType: 'track' }),
        })
            .then(response => response.json())
            .then(data => {
                displaySearchResults(data.tracks.items);
            })
            .catch(error => {
                console.error('Error during Spotify search:', error);
            });
    }
    function displaySelectedTrack(item) {
        // Assuming `item` has a property `uri` that contains the Spotify URI
        const spotifyUri = item.uri; // You might need to adjust this based on your data structure

        // Update song name in SVG text element
        const songNameElement = document.getElementById('text-front_cover-Song');
        if (songNameElement) {
            songNameElement.textContent = item.name;
        }
        const artistAlbumElement = document.getElementById('text-front_cover-Artist');
        if (artistAlbumElement) {
            // Assuming item.artists is an array of artist objects and item.album contains the album name
            const artistNames = item.artists.map(artist => artist.name).join(', ');
            const albumName = item.album.name; // Adjust if your item structure is different
            artistAlbumElement.textContent = `${artistNames}, ${albumName}`;
        }

        // Fetch QR code for the Spotify URI
        const serverQREndpoint = `https://i.expresscreations.co.uk/spotify/qr?uri=${encodeURIComponent(spotifyUri)}`;
        fetch(serverQREndpoint)
            .then(response => response.json())
            .then(data => {
                const qrImage = document.getElementById('music_qr');
                if (qrImage) {
                    // Directly use the qrCodeDataUri from the response without adding a prefix
                    const imageDataUri = data.qrCodeDataUri; // This already includes 'data:image/png;base64,'
                    // For SVG2
                    qrImage.setAttribute('href', imageDataUri);
                    // For SVG 1.1 compatibility
                    qrImage.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', imageDataUri);
                    qrImage.style.display = 'block';
                }
            })
            .catch(error => {
                console.error('Error fetching QR code:', error);
            });

        // Proceed with displaying the selected track as before
        containerDiv.innerHTML = `
        <div class="selected-track">
            <div class="track-image">
                <img src="${item.album.images[0].url}" alt="${item.name}" style="width: 50px; height: 50px;" />
                <button id="closeTrack" class="close-button">X</button>
            </div>
            <div class="track-details">
                <strong>${item.name}</strong>
                <span>${item.artists.map(artist => artist.name).join(', ')}</span>
            </div>
        </div>
        <button id="uploadPhotoButton" class="upload-photo-button">Upload Your Photo</button>
        <input type="file" id="fileInput" accept="image/*" style="display: none;" />

    `;

        document.getElementById('uploadPhotoButton').addEventListener('click', function () {
            document.getElementById('fileInput').click();
        });


        document.getElementById('fileInput').addEventListener('change', function () {
            const file = this.files[0];
            if (file) {
                const reader = new FileReader();
                reader.onload = function (e) {
                    const svgImage = document.querySelector('image[data-item-id="music_photo"]');
                    if (svgImage) {
                        svgImage.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', e.target.result);
                    }
                };
                reader.readAsDataURL(file);
                containerDiv.classList.remove('open');
            }
        });


        document.getElementById('closeTrack').addEventListener('click', function () {
            // Call resetSearchInterface to clear and reset the search interface
            event.preventDefault();
            event.stopPropagation();
            resetSearchInterface();
        });

    }

    // CSS updates for close and upload buttons as previously described

    function displaySearchResults(searchResults) {
        // Ensure a single modal is used for displaying search results
        let modal = document.getElementById('searchResultsModal');
        if (!modal) {
            modal = document.createElement('div');
            modal.id = 'searchResultsModal';
            modal.style.display = 'none';
            modal.classList.add('modal');
            document.body.appendChild(modal);

            // Modal content container
            const modalContent = document.createElement('div');
            modalContent.classList.add('music_modal-content');
            modal.appendChild(modalContent);

            // Close button for modal
            const closeButton = document.createElement('span');
            closeButton.classList.add('close');
            closeButton.innerHTML = '&times;';
            closeButton.onclick = function () {
                modal.style.display = 'none';
            };
            modalContent.appendChild(closeButton);

            // Create and append an initially empty results container
            const resultsContainer = document.createElement('div');
            resultsContainer.id = 'resultsContainer';
            resultsContainer.classList.add('results-container');
            modalContent.appendChild(resultsContainer);
        }

        // Get the existing results container and clear previous results
        const resultsContainer = document.getElementById('resultsContainer');
        resultsContainer.innerHTML = ''; // Clear any previous content

        // Append each search result to the results container
        searchResults.forEach((item) => {
            const resultDiv = document.createElement('div');
            resultDiv.classList.add('result-item');
            resultDiv.innerHTML = `
                <img src="${item.album.images[0].url}" alt="${item.name}" />
                <div class="details">
                    <strong>${item.name}</strong>
                    <span>${item.artists.map(artist => artist.name).join(', ')}</span>
                </div>
            `;

            // Event listener for selecting a track
            resultDiv.addEventListener('click', function () {
                event.preventDefault();
                event.stopPropagation();
                displaySelectedTrack(item); // Call displaySelectedTrack with the selected item
                modal.style.display = 'none'; // Close modal on selection
            });

            resultsContainer.appendChild(resultDiv);
        });

        // Display the modal
        modal.style.display = 'block';
    }
}



// Initialize Spotify tab when page loads

// Call setupSpotifyTab when the Spotify tab is clicked (not shown here)

/*AI Background/*/
function setupAIBackgroundTab(selectedTab) {

    const containerDiv = document.querySelector('.editor-container');

    // Clear existing content
    containerDiv.innerHTML = '';

    // Create textarea for background description
    const backgroundTextarea = document.createElement('textarea');
    backgroundTextarea.id = 'aiBackgroundTextarea';
    backgroundTextarea.placeholder = 'Describe your desired background e.g., Sunset over a beach...';
    backgroundTextarea.rows = 4; // Adjust the number of rows as needed
    backgroundTextarea.style.width = '100%'; // Adjust styling as needed

    // Create generate button
    const generateButton = document.createElement('button');
    generateButton.id = 'generateButton';
    generateButton.textContent = 'Generate';
    generateButton.type = 'button';  // Set the button type to 'button'
    generateButton.onclick = () => generateAIBackground();

    // Append elements to the container
    containerDiv.appendChild(backgroundTextarea);
    containerDiv.appendChild(generateButton);
}

function generateAIBackground() {
    const userInput = document.getElementById('aiBackgroundTextarea').value;

    generateContentUniversal('background', 0, userInput, `${currentPage}-customBackgroundRect`);
    console.log('Generating AI Background for:', userInput);

}


let clickHandler; // Declare at a scope accessible to both functions
/**
 * Handles the configuration for tabs based on the product and page.
 * @param {string} productData - The SKU or product data.
 * @param {string} page - The current page.
 */
function handleTabConfiguration(productData, page) {
    const configForPage = productConfigurations[productData] && productConfigurations[productData][page];
    const { stickers, frames, text, name, ai_background, spotify } = configForPage || {};

    const tabConfig = {
        'spotify': {
            itemsValue: spotify,
            handler: (selectedTab, itemsValue) => setupSpotifyTab(selectedTab),
            friendlyName: "Customise"
        },
        'user_video_DISABLE': {
            itemsValue: [],
            handler: (selectedTab, itemsValue) => alert('video'),
            friendlyName: "Add a Video"
        },
        'stickers': {
            itemsValue: stickers ? stickerConfigurations[stickers] : null,
            handler: (selectedTab, itemsValue) => populateItems('sticker', itemsValue),
            friendlyName: "Stickers"
        },
        'frames': {
            itemsValue: frames,
            handler: (selectedTab, itemsValue) => populateItems('frame', itemsValue),
            friendlyName: "Frames"
        },
        'ai_background_DISABLE': {
            itemsValue: ai_background,
            handler: (selectedTab, itemsValue) => setupAIBackgroundTab(selectedTab),
            friendlyName: "AI Background"
        },


        // 'fonts': {
        //      itemsValue: [],
        //       handler: (selectedTab, itemsValue) => populateFontsAndControls(),
        //       friendlyName: "Fonts"
        //   }, 

    };

    const tabParent = document.getElementById('editor-tabs');

    const existingTabs = tabParent.querySelectorAll('.editor-tab.show');
    existingTabs.forEach(tab => {
        tab.classList.remove('show');
    });

    setTimeout(() => {
        tabParent.innerHTML = '';

        for (const [tabKey, tabValue] of Object.entries(tabConfig)) {
            let shouldCreateTab = configForPage && (tabKey in configForPage || (tabKey === 'fonts' && (text || name)));

            if (shouldCreateTab) {
                const tabElement = document.createElement('div');
                tabElement.className = 'editor-tab';
                tabElement.dataset.tab = tabKey;

                const imgElement = document.createElement('img');


                if (tabKey === 'ai_background') {
                    imgElement.src = 'https://ec-i.s3.eu-west-2.amazonaws.com/ai_background.png'; // AI background image URL
                }


                else if (tabKey === 'stickers') {
                    imgElement.src = 'https://ec-i.s3.eu-west-2.amazonaws.com/stickers/flowers_sticker.png'; // AI background image URL
                }


                else if (tabKey === 'frames') {
                    imgElement.src = 'https://ec-i.s3.eu-west-2.amazonaws.com/frames/11.png'; // AI background image URL
                }

                else if (tabKey === 'spotify') {
                    imgElement.src = 'https://ec-i.s3.eu-west-2.amazonaws.com/i/music_icon.png'; // AI background image URL
                }

                else {
                    imgElement.src = 'https://placehold.co/100x100'; // Default placeholder image
                }

                imgElement.style.width = '48px';
                imgElement.alt = `${tabKey} Icon`;

                const textElement = document.createElement('div');
                textElement.textContent = tabValue.friendlyName || (tabKey.charAt(0).toUpperCase() + tabKey.slice(1));

                tabElement.appendChild(imgElement);
                tabElement.appendChild(textElement);

                tabParent.appendChild(tabElement);

                setTimeout(() => {
                    tabElement.classList.add('show');
                }, 0);
            }
        }
    }, 250);

    // Remove previous event listener if it exists
    if (clickHandler) {
        tabParent.removeEventListener('click', clickHandler);
    }

    // New event listener
    clickHandler = function (event) {
        const tab = event.target.closest('.editor-tab');
        if (tab) {
            handleTabClick(tab, tabConfig);
        }
    };

    tabParent.addEventListener('click', clickHandler);
}

let activePage = null;

function handleTrayCreation(page) {
    console.log("handleTrayCreation called"); // Debug log
    console.log("Active page is: ", activePage, "Current page is: ", page); // Debug log

    if (!trayCreated && page === activePage) {
        console.log("Creating carousel tray"); // Debug log
        createCarouselTray();
        trayCreated = true;
    }
}
export function closeTab() {
    const carouselContainer = document.querySelector('.editor-container');
    carouselContainer.classList.remove('open');
    deactivateAllTabs();
    carouselContainer.setAttribute('data-current-tab', '');
}

function deactivateAllTabs() {
    document.querySelectorAll('.editor-tab').forEach(t => t.classList.remove('active'));
}
/**
 * Handles the tab click event.
 * @param {Element} tab - The clicked tab element.
 * @param {Object} tabConfig - The configuration for available tabs.
 */
/**
 * Handles the tab click event.
 * @param {Element} tab - The clicked tab element.
 * @param {Object} tabConfig - The configuration for available tabs.
 */
function handleTabClick(tab, tabConfig) {
    console.log("Available Tabs:", tabConfig);

    const selectedTab = tab.dataset.tab;
    if (selectedTab === 'fonts') {
        initializeSelectedText(); // Initialize selected text when font tab is opened
    }
    console.log("Tab clicked:", selectedTab);

    const carouselContainer = document.querySelector('.editor-container');

    // Check if this tab is already open
    if (carouselContainer.getAttribute('data-current-tab') === selectedTab) {
        closeTab();
        return;
    }

    deactivateAllTabs();
    tab.classList.add('active');
    carouselContainer.innerHTML = '';

    if (selectedTab === 'close') {
        closeTab();
        return;
    }

    const config = tabConfig[selectedTab];
    console.log("Config for clicked tab:", config);

    if (config && (config.itemsValue || selectedTab === 'fonts')) {
        config.handler(selectedTab, config.itemsValue);
        setupDraggable(`.${selectedTab}-item`, selectedTab);
    }

    carouselContainer.setAttribute('data-current-tab', selectedTab);
    carouselContainer.classList.add('open');

    // Scroll into view only on mobile devices
    if (window.innerWidth <= 768) { // 768px is a common breakpoint for mobile devices
        carouselContainer.scrollIntoView({ behavior: 'smooth' });
    }

    carouselContainer.focus();
}


/**
 * Creates an item on the canvas based on the given configurations.
 * @param {SVG} drawInstance - The SVG.js drawing instance.
 * @param {Object} itemConfig - The configuration data for the item.
 * @param {string} type - The type of the item (e.g., 'photo', 'sticker').
 * @return {SVG.Image} The created image instance.
 */

// Update the existing function to handle the new shape attribute
export function createItemOnCanvas(drawInstance, itemConfig, type) {
    // Destructure properties from itemConfig with default values
    const {
        width = 60,
        height = 60,
        x = 0,
        y = 0,
        url,
        id,
        zIndex,
        shape,
        shape_colour,
        style, // New attribute for styles like 'white_photo'
        rotation // New attribute for rotation
    } = itemConfig;

    // Create the clip-path for heart shape if needed
    let clipPath;
    if (shape === 'heart') {
        // Define the path of the heart shape based on the SVG provided
        const heartPath = 'M0 200 v-200 h200 a100,100 90 0,1 0,200 a100,100 90 0,1 -200,0 z';

        // Calculate scale to fit the config width and height, since the original SVG is 342x315
        const scaleWidth = width / 342;
        const scaleHeight = height / 315;

        // Apply the rotation transformation with the appropriate scale
        const rotationTransformation = {
            rotate: 225,
            ox: 150 * scaleWidth + x,  // Adjust origin of rotation based on the scaled width and position x
            oy: 121 * scaleHeight + y  // Adjust origin of rotation based on the scaled height and position y
        };

        // Create heart shape without rotation and scale it according to the item configuration
        clipPath = drawInstance.clip()
            .add(drawInstance.path(heartPath)
                .scale(scaleWidth, scaleHeight)
                .rotate(rotationTransformation.rotate, rotationTransformation.ox, rotationTransformation.oy)
                .move(x, y));

    } else if (shape === 'circle') {
        // Assuming the circle should fit the specified width and height (which should be equal for a perfect circle)
        const radius = Math.min(width, height) / 2;
        const circlePath = drawInstance.circle(width).radius(radius).center(x + radius, y + radius);

        clipPath = drawInstance.clip().add(circlePath);
    }

    // Create and apply clipPath to a background shape if shape_colour is defined
    if (shape_colour && clipPath) {
        const backgroundShape = drawInstance.rect(width, height).move(x, y).fill(shape_colour);
        // Apply the clip path to the background shape
        backgroundShape.clipWith(clipPath);
    }

    // Create the image on the SVG canvas with the specified attributes
    const image = drawInstance.image(url).size(width, height).move(x, y);

    // Apply the clip-path if it's defined
    if (clipPath) {
        image.clipWith(clipPath);
    }

    // Apply rotation if specified
    if (rotation) {
        image.rotate(rotation, x + width / 2, y + height / 2); // Rotating around the center of the image
    }

    // Continue with the rest of the function as before
    const itemId = id || generateUniqueId(type);
    image.node.setAttribute('data-item-id', itemId);

    if (zIndex) {
        image.node.style.zIndex = zIndex;
    }

    const currentPageConfig = productConfigurations[SKU] && productConfigurations[SKU][currentPage];
    if (type === 'user_photo' && currentPageConfig && currentPageConfig.user_photo.some(photo => photo.url && photo.url === url)) {
        image.node.setAttribute('data-placeholder', 'true');
        const imageTransformation = currentPageConfig.user_photo.find(photo => photo.url === url)?.image_transformation;
        if (imageTransformation) {
            image.node.setAttribute('data-image-transformation', imageTransformation);
        }

        // Check if the blur filter is already defined; if not, create and append it
        let svgRoot = image.node.closest('svg');
        if (!svgRoot.getElementById('blurFilter')) {
            let defs = svgRoot.querySelector('defs') || document.createElementNS('http://www.w3.org/2000/svg', 'defs');
            svgRoot.prepend(defs); // Ensure the defs is the first child of the SVG

            let filter = document.createElementNS('http://www.w3.org/2000/svg', 'filter');
            filter.setAttribute('id', 'blurFilter');
            filter.innerHTML = '<feGaussianBlur in="SourceGraphic" stdDeviation="5"/>';

            defs.appendChild(filter);
        }

        // Apply the blur effect by setting the filter attribute
        image.node.setAttribute('filter', 'url(#blurFilter)');
    }

    if (type === 'user_photo' && itemConfig.text) {
        // Determine the central position to place the text over the photo
        const textX = x + width / 2; // Center the text horizontally
        const textY = y + height / 2; // Center the text vertically

        // Check if a text element for this photo already exists
        let existingTextElement = document.querySelector(`#user-photo-text-${itemConfig.id}`); // Standard DOM syntax
        if (!existingTextElement) {
            // If it does not exist, create a new text element and center it over the photo
            drawInstance.text(itemConfig.text)
                .move(textX, textY)
                .font({ family: 'Arial', size: 12, weight: '800' })
                .fill('orange')
                .stroke({ color: 'white', width: 1 }) // Adding a white border
                .attr({
                    'id': `user-photo-text-${itemConfig.id}`,
                    'text-anchor': 'middle', // This centers the text horizontally around textX
                    'dominant-baseline': 'middle', // This centers the text vertically around textY
                    'stroke': 'white', // Border color
                    'stroke-width': '1px' // Border width
                });
        } else {
            // If the text element exists, update the text content and re-center it
            existingTextElement
                .text(itemConfig.text)
                .attr({
                    'x': textX, // Ensuring it's re-centered if the text changes
                    'y': textY,
                    'text-anchor': 'middle',
                    'dominant-baseline': 'middle'
                });
        }
    }

    if (type === 'user_photo' && style === 'white_photo') {
        const borderRect = drawInstance.rect(width, height)
            .move(x, y)
            .fill('none')
            .stroke({ color: 'white', width: 20 });

        // Apply rotation to the border if specified
        if (rotation) {
            borderRect.rotate(rotation, x + width / 2, y + height / 2); // Rotating around the center of the image
        }

        // Move the border to the front
        borderRect.front();
    }

    return image;
}



export let lastClickedPlaceholder = null;
/**
 * Sets up items on the canvas based on the given configurations and state.
 * @param {SVG} drawInstance - The SVG.js drawing instance.
 * @param {Object} currentState - The current state of the canvas.
 * @param {Object} defaultConfig - The default configurations for the canvas.
 * @param {string} product_data - The SKU or product data.
 * @param {string} type - The type of the item (e.g., 'sticker', 'photo').
 */
export function setupItemsOnCanvas(drawInstance, currentState, defaultConfig, product_data, type) {
    const itemsArray = type === 'sticker' ? currentState.stickers : currentState.user_photo;
    const defaultItemsConfig = type === 'sticker' ? defaultConfig.stickers : defaultConfig.user_photo;

    // Helper function to create and setup item
    const createAndSetupItem = (itemConfig) => {
        const { x = 0, y = 0 } = itemConfig;
        const item = createItemOnCanvas(drawInstance, itemConfig, type);
        item.move(x, y);

        if (type === 'sticker') {
            makeDraggable(item);


            item.on('click', function (event) {
                event.stopPropagation();
                showItemOverlay(item, type);
            });
        }

        else if (type === 'user_photo') {
            item.on('click', function (event) {
                event.stopPropagation();
                lastClickedPlaceholder = item;
                document.getElementById('photoInput').click();
            });



        }

        attachItemListeners(item, itemConfig, type, product_data);
    };


    if (Array.isArray(itemsArray)) {
        itemsArray
            .filter(item => Object.keys(item).length > 0)  // Only items with one or more properties
            .forEach(createAndSetupItem);
    } else if (Array.isArray(defaultItemsConfig)) {
        defaultItemsConfig
            .filter(item => Object.keys(item).length > 0)  // Only items with one or more properties
            .forEach(createAndSetupItem);
    } else {
        console.warn('Neither itemsArray nor defaultItemsConfig are arrays');
    }

}

/**
 * Appends a sticker to the canvas at the specified coordinates.
 * @param {string} stickerUrl - The URL of the sticker image.
 * @param {number} x - The x-coordinate for the sticker.
 * @param {number} y - The y-coordinate for the sticker.
 */
export function appendStickerToCanvas(stickerUrl, x, y) {
    const stickerID = generateUniqueId('sticker');
    const product_data = SKU;
    zIndexCounter++;

    const image = draw[currentPage].image(stickerUrl).size(60, 60).move(x, y);
    image.node.setAttribute('data-item-id', stickerID);
    image.front();

    //  cardState[product_data][currentPage].stickers.push({
    //      id: stickerID,
    //       url: stickerUrl,
    //      x,
    //     y,
    //     zIndex: zIndexCounter
    //  });

    image.on('click', function (event) {
        event.stopPropagation();
        showItemOverlay(image, 'sticker');
    });

    // Ensure the sticker is draggable only once
    if (!image.node.hasAttribute('data-draggable-initialized')) {
        makeDraggable(image);
        image.node.setAttribute('data-draggable-initialized', 'true');
    }
}

export function showcaseEditableSVGElements(elements) {
    if (!elements || !elements.forEach) {
        console.error("The provided elements are either undefined or not iterable.");
        return;
    }

    const glowAnimation = keyframes => {
        let style = document.createElement("style");
        style.innerHTML = `
            @keyframes glow {
                ${keyframes}
            }
        `;
        document.head.appendChild(style);
    };

    glowAnimation(`
        0% { filter: brightness(1); transform: scale(1); }
        50% { filter: brightness(1.5); transform: scale(1.1); }
        100% { filter: brightness(1); transform: scale(1); }
    `);

    // Group elements by type
    const groups = {};
    elements.forEach(element => {
        const type = element.tagName.toLowerCase(); // e.g., 'text', 'image'
        if (!groups[type]) {
            groups[type] = [];
        }
        groups[type].push(element);
    });

    // Animate each group, one second apart
    let groupDelay = 0;
    for (const type in groups) {
        setTimeout(() => {
            groups[type].forEach((element, index) => {
                setTimeout(() => {
                    element.style.transition = 'all 0.5s';
                    element.style.animation = 'glow 0.5s forwards';
                    setTimeout(() => {
                        element.style.animation = ''; // Reset animation
                    }, 500);
                }, index * 600);
            });
        }, groupDelay);
        groupDelay += 500; // Add a 1-second delay between each group
    }
}





export function updateCardStateWithItemProperties(item, type) {

    //will rework this function
    const itemId = item.node.getAttribute('data-item-id');
    const product_data = SKU
    const itemState = cardState[product_data][currentPage][type].find(item => item.id === itemId);

    if (itemState) {
        itemState.x = item.x();
        itemState.y = item.y();
        itemState.width = item.width();
        itemState.height = item.height();
    }
}



const setupBackgroundAndText = async (drawInstance, defaultConfig, currentState, page) => {



    if (drawInstance && typeof drawInstance.rect === 'function') {
        const { page_size = '100x100', medium_effect } = defaultConfig;
        const [width, height] = page_size.split('x').map(Number);
        const backgroundRect = drawInstance.rect(width, height).move(0, 0).fill(defaultConfig.background);
        console.log("backgroundRect is:", backgroundRect);

        try {
            backgroundRect.attr({ id: `${page}-customBackgroundRect` });

            //NOT WORKING EFFECT

            // Generate a unique ID for the filter
            const uniqueFilterId = `${page}-acrylicEffectFilter-${Date.now()}`;


            if (medium_effect === 'acrylic') {
                // Create the filter for the acrylic effect
                const acrylicEffectFilter = drawInstance.filterWith(add => {
                    // Define the lighting to simulate a glossy surface
                    add.specularLighting(1, '#ffffff', 1, 20).result('specLighting');

                    // Define the base blur to simulate the acrylic depth
                    add.gaussianBlur(4).in(add.$sourceAlpha).result('blur');

                    // Offset for shadow, affecting only the alpha channel to preserve color transparency
                    add.offset(5, 5).in('blur').result('offsetShadow');

                    // Reduce opacity of the shadow to maintain visibility of details below
                    add.componentTransfer({ a: { type: 'linear', slope: 0.3 } }).in('offsetShadow').result('shadowComponentTransfer');

                    // Apply the lighting to create a glossy specular highlight without obscuring the base image
                    add.composite(add.$source, 'specLighting', 'atop').result('glossySurface');

                    // Increased displacement map to simulate a 2cm thickness
                    const displacementScale = 20; // Adjust this value to achieve the desired thickness effect
                    add.displacementMap(add.$source, 'blur', displacementScale, 'R', 'G').in(add.$source).result('displacement');

                    // Merge the effects to create the final appearance, with the gloss on top
                    add.merge('displacement', 'shadowComponentTransfer', 'glossySurface');
                }).attr({
                    id: `${page}-acrylicEffectFilter`
                });
                // Apply the acrylic effect filter to the backgroundRect
                backgroundRect.attr('filter', `url(#${uniqueFilterId})`);

            }

            if (medium_effect === 'acrylic_print') {
                // Generate a unique ID for the filter
                const uniqueFilterId = `${page}-acrylicEffectFilter-${Date.now()}`;

                const acrylicEffectFilter = drawInstance.filterWith(add => {
                    // Start by adding a drop shadow to simulate depth. 
                    const dropShadow = add.offset(5, 5).in(add.$sourceAlpha).result('dropShadowOffset');
                    add.gaussianBlur(2).in('dropShadowOffset').result('dropShadowBlur');
                    const shadowComponentTransfer = add.componentTransfer({
                        a: { type: 'linear', slope: 0.5 } // Adjust alpha component of drop shadow
                    }).in('dropShadowBlur').result('dropShadowComponentTransfer');

                    // Simulate the acrylic depth with a displacement map
                    add.displacementMap(add.$source, 'dropShadowComponentTransfer', 10, 'R', 'G').result('acrylicDisplacement');

                    // Add specular lighting to give it a shiny reflection effect
                    add.specularLighting(0.5, '#FFFFFF', 1, 20).in('acrylicDisplacement').result('lightEffect');

                    // Merge effects to create the final appearance
                    add.merge('lightEffect', add.$source);
                }).attr({ id: uniqueFilterId });

                // Apply the filter to the rectangle
                backgroundRect.attr('filter', `url(#${uniqueFilterId})`);
            }
        } catch (e) {
            console.error("Error setting attributes:", e);
        }
    }

    if (Array.isArray(defaultConfig.text)) {
        for (const textConfig of defaultConfig.text) {
            console.log("Processing textConfig:", textConfig);

            const textValue = currentState && currentState.text && currentState.text.value
                ? currentState.text.value
                : textConfig.value;

            if (textValue) {
                await loadFont(textConfig.font); // Wait for the font to load

                const textElement = drawInstance.text(textValue)
                    .move(textConfig.x, textConfig.y)
                    .id(`text-${page}-${textConfig.value.replace(/\s+/g, '-')}`)
                    .font({
                        family: textConfig.font || 'Arial',
                        size: textConfig.size || 20,
                        fill: textConfig.color || '#000',
                        weight: textConfig.weight || 400 // Default to normal weight if not specified
                    })
                    .attr({
                        "text-anchor": textConfig.anchor || "middle" // default to "start" if not specified
                    });
                console.log("Created textElement:", textElement);

                // Apply shadow if shadow config exists
                if (textConfig.shadow) {
                    textElement.filterWith(function (add) {
                        var blur = add.offset(textConfig.shadow.offsetX, textConfig.shadow.offsetY)
                            .in(add.$sourceAlpha)
                            .gaussianBlur(textConfig.shadow.blurRadius);

                        add.blend(add.$source, blur)
                            .attr({
                                color: textConfig.shadow.color
                            });
                    });
                }

                // Make text editable only if 'edit' is true
                if (textConfig.edit === true) {
                    console.log("Making text editable for:", textConfig.value);
                    createEditableText(textElement, `editableText-${textConfig.value}`, `${page}-container`, page, textConfig);
                }
            }
        }
    }



};
function wrapAndCenterSVGText(svgTextElement, svgWidth, svgHeight, maxWidth, maxHeight) {
    let lineHeight = 1.2;  // Adjust line height as needed
    let fontSize = parseInt(window.getComputedStyle(svgTextElement, null).getPropertyValue('font-size'), 10);

    // Function to split text into lines
    function splitIntoLines(text) {
        const words = text.split(' ');
        let lines = [];
        let currentLine = words[0];

        for (let i = 1; i < words.length; i++) {
            let word = words[i];
            let width = measureTextWidth(currentLine + " " + word, fontSize);
            if (width < maxWidth) {
                currentLine += " " + word;
            } else {
                lines.push(currentLine);
                currentLine = word;
            }
        }
        lines.push(currentLine); // Push the last line
        return lines;
    }

    // Function to measure text width
    function measureTextWidth(text, fontSize) {
        // Use canvas measureText to estimate the width
        const canvas = measureTextWidth.canvas || (measureTextWidth.canvas = document.createElement("canvas"));
        const context = canvas.getContext("2d");
        context.font = `${fontSize}px Arial`;  // Use the same font settings
        return context.measureText(text).width;
    }

    // Split text and create tspans
    const lines = splitIntoLines(svgTextElement.textContent);
    svgTextElement.textContent = '';  // Clear current text
    lines.forEach((line, index) => {
        const tspan = document.createElementNS("http://www.w3.org/2000/svg", "tspan");
        tspan.setAttribute('x', '0');
        tspan.setAttribute('dy', index === 0 ? '0' : `${lineHeight}em`);
        tspan.textContent = line;
        svgTextElement.appendChild(tspan);
    });

    // Recalculate the position
    const textBBox = svgTextElement.getBBox();
    const xCenter = 20;//(svgWidth - textBBox.width) / 2;
    const yCenter = -50;//(svgHeight - textBBox.height) / 2;
    svgTextElement.setAttribute("transform", `translate(${xCenter}, ${yCenter})`);
}


/**
 * Sets up the name text element on the canvas.
 * @param {SVG} drawInstance - The SVG.js drawing instance.
 * @param {Object} defaultConfig - The default configurations for the canvas.
 * @param {Object} currentState - The current state of the canvas.
 * @param {string} page - The current page name.
 */
const setupName = (drawInstance, defaultConfig, currentState, page) => {
    // Extract name configuration and set default values
    const nameConfig = defaultConfig.name || {};
    const {
        font = 'Arial',
        x = 170, // Use the x value from the config or default to 170
        y = 315, // Use the y value from the config or default to 270
        size = 35,
        color = '#fff',
        anchor = 'middle',
        weight = 800, // Default weight if not specified
        r // Add the rotation property
    } = nameConfig;

    // Determine the text value for the name
    const nameValue = nameConfig.value || 'Enter Name';

    if (nameValue) {
        loadFont(font).then(() => {
            // Create the text element with the specified x and y values and apply the weight
            const namePlaceholder = drawInstance.text(nameValue)
                .move(x, Number(y))
                .fill(color)
                .font({
                    family: font,
                    size: size,
                    weight: weight // Apply the weight from the config
                })
                .attr({
                    "text-anchor": anchor,
                    "dominant-baseline": "hanging"
                })
                .id(`name-${page}`);

            // Rotate the name if the 'r' attribute exists in the nameConfig
            if (typeof r !== 'undefined') {
                namePlaceholder.rotate(r);
            }

            // Adjust font size to fit within the maximum width if needed
            // adjustFontSize(namePlaceholder);

            // Remove any additional transformations that may be applied
            //  namePlaceholder.transform({ translateX: 0, translateY: 0 });

            // Make the text element editable and animate it
            createEditableText(namePlaceholder, 'nameText', `${page}-container`, page, defaultConfig);
            animateName(namePlaceholder);
        }).catch((error) => {
            console.error('Error loading font:', error);
        });
    };
};



function updateSVGText(svgElementId, newText) {
    const svgTextElement = document.getElementById(svgElementId);
    if (svgTextElement) {
        // Clear existing content
        while (svgTextElement.firstChild) {
            svgTextElement.removeChild(svgTextElement.firstChild);
        }

        // Add new text
        const textNode = document.createTextNode(newText);
        svgTextElement.appendChild(textNode);
    }
}
function updateMessageCardSVG() {
    const messageTextArea = document.getElementById('message-card');
    if (messageTextArea) {
        var svgTspan = document.querySelector('#text-inside_right-Message-Card tspan');
        var textElement = document.querySelector('#text-inside_right-Message-Card');
        console.log(textElement);

        console.log(svgTspan);
        if (svgTspan) {
            svgTspan.textContent = messageTextArea.value;
        } else {
            console.error('SVG tspan element not found');
        }

        if (textElement) {
            while (textElement.firstChild) {
                textElement.removeChild(textElement.firstChild);
            }

            if (textElement) {
                textElement.textContent = messageTextArea.value;
                setTimeout(() => {
                    wrapAndCenterSVGText(textElement, 340, 481, 300, 300); // Use correct dimensions
                }, 0);
            } else {
                console.error('SVG text element for message card not found');
            }
        }
    }


}
function debounce(func, wait, immediate) {
    let timeout;
    return function () {
        const context = this, args = arguments;
        const later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

// Utilize MutationObserver to listen for changes in the textarea and update the SVG accordingly

document.addEventListener('DOMContentLoaded', function () {
    function setupMutationObserver() {
        const messageTextArea = document.getElementById('message-card');
        if (!messageTextArea) {
            console.error('Message textarea not found');
            return;
        }

        let lastKnownValue = messageTextArea.value; // Use .value for textarea

        const updateOnMutation = () => {
            updateMessageCardSVG();
        };

        const observer = new MutationObserver(updateOnMutation);
        observer.observe(messageTextArea, { childList: true, characterData: true, subtree: true });

        messageTextArea.addEventListener('input', updateOnMutation);

        // Function to periodically check for changes in the message area
        const checkForChanges = () => {
            const currentValue = messageTextArea.value; // Use .value for textarea
            if (currentValue !== lastKnownValue) {
                lastKnownValue = currentValue;
                updateMessageCardSVG();
            }
        };

        // Set up a periodic check every 500 milliseconds
        setInterval(checkForChanges, 500);
    }
    setupMutationObserver();

    const messageTextArea = document.getElementById('message-card');
    const recipientNameInput = document.getElementById('recipient-name-input');

    if (messageTextArea) {
        messageTextArea.addEventListener('input', debounce(updateMessageCardSVG, 300));
    }


    if (recipientNameInput) {
        recipientNameInput.addEventListener('input', function () {
            updateSVGText('name-front_cover', recipientNameInput.value);

        });
    }
});
// Additional function or modifications here for creating editable SVG elements...


// .
/**
 * Creates an editable text element on the canvas.
 * @param {SVG.Text} textElement - The SVG text element.
 * @param {string} inputId - The ID for the input element.
 * @param {string} container - The ID of the container element.
 * @param {string} page - The current page name.
 */
function createEditableText(textElement, inputId, container, page, config) {
    textElement.attr('pointer-events', 'bounding-box');

    textElement.on('click', (event) => {
        const { x, y } = textElement.bbox();
        const bbox = textElement.bbox();
        const containerRect = document.getElementById(container).getBoundingClientRect();
        const scrollX = window.scrollX || window.pageXOffset;
        const scrollY = window.scrollY || window.pageYOffset;
        const textValue = textElement.text();

        let input;
        if (config.maxWidth && config.maxHeight) {
            input = document.createElement('textarea');
            input.style.resize = 'none';
            input.maxLength = 255;
            input.rows = 3; // Set the number of rows to 3 for the textarea
            input.style.maxWidth = '300px'; // Set the max width to 300px
            // Set height and other styles as required
        } else {
            input = document.createElement('input');
            input.type = 'text';
            input.maxLength = 40;
            // If you're using an input element instead of textarea, set its max width here
        }

        input.id = inputId;
        input.value = textElement.text();
        const inputWidth = Math.max(bbox.width, textValue.trim() === '' ? 100 : bbox.width);
        const fontSize = parseInt(window.getComputedStyle(textElement.node).fontSize);
        Object.assign(input.style, {
            position: 'absolute',
            left: `${containerRect.left + bbox.x + scrollX}px`,
            top: `${containerRect.top + bbox.y + scrollY}px`,
            width: `${inputWidth}px`,
            minHeight: '3em', // Ensure the height is at least the size of 3 lines
            maxWidth: config.maxWidth ? `${config.maxWidth}px` : 'none',
            maxHeight: config.maxHeight ? `${config.maxHeight}px` : 'none',
            border: '1px solid orange',
            outline: 'none',
            background: 'white', // Change to white background similar to a standard textarea
            textAlign: 'center',
            fontSize: `${fontSize}px`,
            zIndex: 1000 // Make sure it's on top of other elements
        });




        input.style.position = 'absolute';
        input.style.left = `${containerRect.left + bbox.x + scrollX}px`;
        input.style.top = `${containerRect.top + bbox.y + scrollY}px`;
        input.style.zIndex = '10000'; // High enough to be on top of everything
        input.style.width = `${bbox.width}px`;
        input.style.height = `${bbox.height}px`;
        input.style.maxWidth = config.maxWidth ? `${config.maxWidth}px` : `${bbox.width}px`;
        input.style.maxHeight = config.maxHeight ? `${config.maxHeight}px` : `${bbox.height}px`;
        input.style.border = 'none';
        input.style.outline = 'none';
        input.style.background = 'rgba(255, 255, 255, 0.5)';
        input.style.textAlign = textElement.node.style.textAnchor === 'middle' ? 'center' : textElement.node.style.textAlign;
        input.style.fontSize = `${fontSize}px`;

        document.body.appendChild(input);
        input.onfocus = () => {
            input.select();
        };

        input.focus();
        input.onblur = () => {
            const oldText = textElement.text();
            const newText = input.value || oldText;


            input.remove();
            // Clear existing SVG text content

            //Sync Shopify Fields
            if (textElement.id() === 'text-inside_right-Message-Card') {
                const textarea = document.getElementById('message-card');
                if (textarea) {
                    console.log("Updating textarea with new text:", newText);
                    textarea.value = newText;

                } else {
                    console.error("Textarea not found");
                }
            }

            if (textElement.id() === 'name-front_cover') {
                const recipientNameInput = document.getElementById('recipient-name-input');
                if (recipientNameInput) {
                    console.log("Updating recipient name field with new text:", newText);
                    recipientNameInput.value = newText;
                } else {
                    console.error("Recipient name field not found");
                }

            }
            // #text-inside_right-Message-Card tspan

            var svgTspan = document.querySelector(`#${textElement.id()} tspan`);


            if (svgTspan) {
                svgTspan.textContent = '';
                svgTspan.textContent = newText;
            } else {
                console.error('SVG tspan element not found');
            }

            while (textElement.node.firstChild) {
                textElement.node.removeChild(textElement.node.firstChild);
            }




            textElement.text(newText);
            const svgTextElement = document.querySelector(`#${textElement.id()}`);
            console.log('sss');
            console.log(svgTextElement);


            if (config.maxWidth && config.maxHeight) {
                const svgWidth = 340; // Width of your SVG
                const svgHeight = 481; // Height of your SVG
                wrapAndCenterSVGText(svgTextElement, svgWidth, svgHeight, 300, 300); // maxWidth and maxHeight = 300
            }
            else {
                // Recalculate the center position after the text change               

                if (config.anchor === 'middle') {
                    // Recalculate the center position after the text change               

                    const svgWidth = textElement.parent().width();
                    const textWidth = textElement.node.getBBox().width;
                    const centerX = (svgWidth - textWidth) / 2;
                    textElement.move(centerX, y);
                }


            }

            textElement.fire('textChanged');

            let propertyToUpdate = null;
            if (inputId === 'birthdayText') {
                propertyToUpdate = 'text';
            } else if (inputId === 'nameText') {
                propertyToUpdate = 'name';
            } else {
                console.log("Unknown inputId:", inputId);
            }

            if (propertyToUpdate) {
                // Create actionData based on the property being changed
                const actionData = {};
                actionData[propertyToUpdate] = {
                    value: newText,
                    x: textElement.attr('x'),
                    y: textElement.attr('y')
                };

                // Use handleSVGActions to update the state
                handleSVGActions('UPDATE_PROPERTY', actionData, SKU, page);
            }
        };
    });

    textElement.on('textChanged', () => {
        // Placeholder for future functionality
    });
}


export function animateName(namePlaceholder) {
    setTimeout(() => {
        namePlaceholder.animate(2000, '<>', 0)
            .dmove(-5, 0)
            .during(function (pos) {
                this.dmove(Math.sin(pos * Math.PI * 10) * 2, 0);
            })
            .after(function () {
                namePlaceholder.fire('textChanged');
            });
    }, 1000);
}
/**
 * Populates items in the editor container based on the item type and values.
 * @param {string} itemType - The type of the item (e.g., 'sticker', 'frame', 'font').
 * @param {Array} itemsValue - Array of item URLs.
 */
function populateItems(itemType, itemsValue) {
    const containerDiv = document.querySelector('.editor-container');
    const product_data = SKU;

    // Exit if no items are found
    if (!itemsValue) {
        return;
    }

    // Clear existing content
    containerDiv.innerHTML = '';

    // Helper function to setup draggable elements
    const setupDraggableElement = (element, type) => {
        setupDraggable(`.${type}-item`, type);
    };

    // Helper function to append items to the container
    const appendItemToContainer = (itemUrl) => {
        const itemContainer = document.createElement('div');
        itemContainer.setAttribute('data-url', itemUrl);
        itemContainer.className = `${itemType}-item draggable-item`;

        const itemImg = document.createElement('img');
        itemImg.setAttribute('data-src', itemUrl); // Set data-src instead of src
        Object.assign(itemImg.style, {
            maxWidth: '90px',
            maxHeight: '100%',
            objectFit: 'contain'
        });

        itemContainer.appendChild(itemImg);
        containerDiv.appendChild(itemContainer);
        setupDraggableElement(itemContainer, itemType);
    };

    // Add close button
    const closeButton = document.createElement('i');
    Object.assign(closeButton.style, {
        position: 'absolute',
        right: '0',
        top: '0',
        zIndex: '1001'
    });

    closeButton.className = 'fa fa-times close-tray-button';
    closeButton.onclick = () => {
        containerDiv.classList.remove('open');
    };
    containerDiv.appendChild(closeButton);

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const img = entry.target.querySelector('img');
                img.src = img.getAttribute('data-src');
                observer.unobserve(entry.target);
            }
        });
    }, { root: containerDiv, threshold: 0.1 });  // Adjust the threshold as needed

    itemsValue.forEach((itemUrl) => {
        appendItemToContainer(itemUrl);
        const itemContainer = document.querySelector(`[data-url="${itemUrl}"]`);
        observer.observe(itemContainer);

        itemContainer.onclick = function (event) {
            if (itemType === 'sticker') {
                const stickerID = generateUniqueId('sticker');
                const image = draw[currentPage].image(itemUrl).size(60, 60).move(120, 220);
                image.node.setAttribute('data-item-id', stickerID);
                image.node.setAttribute('data-sticker-url', itemUrl);
                zIndexCounter++;
                itemContainer.style.zIndex = zIndexCounter;
                event.stopPropagation();
                showItemOverlay(image, 'sticker');
                image.on('click', function (event) {
                    event.stopPropagation();
                    showItemOverlay(image, 'sticker');
                });

                // Update the cardState
                const stickerData = {
                    id: stickerID,
                    url: itemUrl,
                    x: 120,
                    y: 220,
                    zIndex: zIndexCounter
                };

                console.log(currentPage);

                handleSVGActions('ADD_STICKER', { sticker: stickerData }, product_data, currentPage);


                makeDraggable(image);
            } else if (itemType === 'frame') {
                const frameID = generateUniqueId('frame');
                const fullImageUrl = itemUrl;
                const frame = draw[currentPage].image(fullImageUrl).size('100%', '100%');

                frame.node.setAttribute('data-item-id', frameID);
                frame.node.style.zIndex = '1'; // Ensure the frame is below the image
                frame.node.style.pointerEvents = 'none'; // Allow click events to pass through the frame

                //handleFrameClick(itemUrl);
            } else if (itemType === 'font') {
                handleFontClick(itemUrl);
            }
        };
    });
}


export function handleFrameDrop(frameUrl) {
    const frameID = generateUniqueId('frame');
    const fullImageUrl = frameUrl;
    const frame = draw[currentPage].image(fullImageUrl).size('100%', '100%');

    frame.node.setAttribute('data-item-id', frameID);
    frame.node.style.zIndex = '1'; // Ensure the frame is below the image
    frame.node.style.pointerEvents = 'none'; // Allow click events to pass through the frame


}

// 3. Handle Fonts
export function handleFontClick(fontUrl) {
    // Placeholder for now
    console.log(`Selected font: ${fontUrl}`);
}


function setupFontDraggable() {
    interact('.font-card').draggable({
        inertia: true,
        modifiers: [
            interact.modifiers.restrictRect({
                restriction: 'parent',
                endOnly: true
            })
        ],
        autoScroll: true,
        listeners: {
            // other listeners...
            end(event) {
                const dropArea = document.getElementById('name-front_cover').getBoundingClientRect();
                if (event.clientX > dropArea.left && event.clientX < dropArea.right &&
                    event.clientY > dropArea.top && event.clientY < dropArea.bottom) {
                    const fontFamily = event.target.dataset.fontName;
                    changeFont(fontFamily);
                }
            }
        }
    });
}

//displayFonts();











const fetchFonts = async () => {
    const response = await fetch(`https://www.googleapis.com/webfonts/v1/webfonts?key=${GOOGLE_API_KEY}`);
    const data = await response.json();
    console.log(data.items);
    return data.items;
};

const fetchAndLoadFont = async (fontName) => {
    const fonts = await fetchFonts();
    if (fonts.some(font => font.family === fontName)) {
        loadFont(fontName);
        return true;
    } else {
        console.error(`Font "${fontName}" is not available in Google Fonts.`);
        return false;
    }
};
const loadFont = async (fontName) => {
    if (!fontName) {
        console.error("fontName is undefined or null");
        return;
    }
    const response = await fetch(`https://fonts.googleapis.com/css2?family=${fontName.replace(/ /g, "+")}`);
    const cssText = await response.text();
    const styleElement = document.createElement("style");
    styleElement.innerHTML = cssText;
    document.head.appendChild(styleElement);
};




let currentSelectedTextElement = null;


async function populateFontsAndControls() {
    try {
        const fonts = await fetchFonts();
        const wrapper = document.querySelector('.editor-container');

        // Helper function for observer
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(async (entry) => {
                if (entry.isIntersecting) {
                    const fontDiv = entry.target;
                    const font = fonts.find(f => f.family === fontDiv.dataset.fontName);

                    const isLoaded = loadFont(font.family);
                    if (isLoaded) {
                        fontDiv.querySelector('.font-name').style.fontFamily = font.family;
                    }
                    observer.unobserve(fontDiv);
                }
            });
        });

        // Create Controls
        createColorPalette(wrapper);
        createFontSizeControl(wrapper);

        for (const font of fonts) {
            const fontDiv = createFontCard(font);
            wrapper.appendChild(fontDiv);
            observer.observe(fontDiv);
        }
    } catch (error) {
        console.error('Error populating fonts and controls:', error);
    }
}
function highlightTextElement(textElement) {
    // Remove existing highlight
    removeExistingHighlight();

    // Calculate bbox for text element
    const bbox = textElement.getBBox();

    // Create a new rect element
    const highlightRect = document.createElementNS("http://www.w3.org/2000/svg", "rect");
    highlightRect.setAttribute('x', bbox.x - 5); // Adjust as needed
    highlightRect.setAttribute('y', bbox.y - 5); // Adjust as needed
    highlightRect.setAttribute('width', bbox.width + 10); // Adjust as needed
    highlightRect.setAttribute('height', bbox.height + 10); // Adjust as needed
    highlightRect.setAttribute('fill', 'none');
    highlightRect.setAttribute('stroke', 'orange');
    highlightRect.setAttribute('stroke-width', '2');
    highlightRect.setAttribute('class', 'text-highlight');

    // Insert the rect before the text element
    textElement.parentNode.insertBefore(highlightRect, textElement);
}

function removeExistingHighlight() {
    const existingHighlight = document.querySelector('.text-highlight');
    if (existingHighlight) {
        existingHighlight.remove();
    }
}


// Helper function to create color palette
function createColorPalette(wrapper) {
    const colorPalette = document.createElement('div');
    colorPalette.id = 'color-palette';
    colorPalette.style.marginTop = '10px';
    const colors = ['#000000'];
    colors.forEach(color => {
        const colorOption = document.createElement('div');
        colorOption.className = 'color-option';
        colorOption.style.backgroundColor = color;
        colorOption.addEventListener('click', function () {
            changeFontColor(color);
            document.querySelectorAll('.color-option').forEach(opt => opt.classList.remove('selected-color'));
            colorOption.classList.add('selected-color');
        });
        colorPalette.appendChild(colorOption);
    });
    wrapper.appendChild(colorPalette);
}

// Helper function to create font size control
function createFontSizeControl(wrapper) {
    const fontSizeControl = document.createElement('div');
    fontSizeControl.className = 'font-size-control';
    const fontSizeLabel = document.createElement('label');
    fontSizeLabel.htmlFor = 'font-size-slider';
    fontSizeLabel.innerText = 'Font Size:';
    fontSizeControl.appendChild(fontSizeLabel);

    const fontSizeSlider = document.createElement('input');
    fontSizeSlider.type = 'range';
    fontSizeSlider.id = 'font-size-slider';
    fontSizeSlider.min = '10';
    fontSizeSlider.max = '100';
    fontSizeSlider.value = '24';
    fontSizeSlider.addEventListener('input', function () {
        changeFontSize(this.value);
        document.getElementById('font-size-display').innerText = this.value;
    });
    fontSizeControl.appendChild(fontSizeSlider);

    const fontSizeDisplay = document.createElement('span');
    fontSizeDisplay.id = 'font-size-display';
    fontSizeDisplay.innerText = fontSizeSlider.value;
    fontSizeControl.appendChild(fontSizeDisplay);

    const fontSizeText = document.createElement('span');
    fontSizeText.innerText = 'px';
    fontSizeControl.appendChild(fontSizeText);

    wrapper.appendChild(fontSizeControl);
}

/**
 * Creates and returns a font card element.
 * @param {Object} font - The font object containing family and other attributes.
 * @returns {HTMLElement} The created font card element.
 */
function createFontCard(font) {
    const fontDiv = document.createElement('div');
    fontDiv.dataset.fontName = font.family;
    fontDiv.className = `font-card draggable-item`;

    const fontName = document.createElement('div');
    fontName.innerText = font.family;
    fontName.classList.add('font-name');

    fontDiv.appendChild(fontName);

    fontDiv.addEventListener('click', () => {
        applyFontToSelectedText(font.family);
    });

    return fontDiv;
}



function changeFont(fontFamily) {
    const textElement = document.getElementById('name-front_cover');
    textElement.style.fontFamily = fontFamily;
}

function changeFontSize(size) {
    const textElement = document.getElementById('name-front_cover');
    textElement.style.fontSize = size + 'px';
}



// DOMContentLoaded listener
document.addEventListener("DOMContentLoaded", async () => {
    console.log("DOMContentLoaded fired");


    // await populateFontsAndControls();
    setupTextElements();
});


function initializeSelectedText() {
    const textElements = document.querySelectorAll('svg text');
    if (textElements.length > 0) {
        currentSelectedTextElement = textElements[0]; // Set the first text element as the selected one
        highlightTextElement(currentSelectedTextElement); // Highlight the first text element
    }
}

function setupTextElements() {
    const textElements = document.querySelectorAll('svg text');
    textElements.forEach(element => {
        console.log('Setting up interactive overlay for:', element);
        createInteractiveOverlay(element);
    });
}
function createInteractiveOverlay(textElement) {
    const bbox = textElement.getBBox();
    const overlay = document.createElementNS("http://www.w3.org/2000/svg", "rect");
    overlay.setAttribute('x', bbox.x);
    overlay.setAttribute('y', bbox.y);
    overlay.setAttribute('width', bbox.width);
    overlay.setAttribute('height', bbox.height);
    overlay.setAttribute('fill', 'transparent');
    overlay.classList.add('text-interactive-overlay');

    textElement.parentNode.insertBefore(overlay, textElement.nextSibling); // insert after the textElement

    overlay.addEventListener('click', function (event) {
        textElementClickHandler(textElement, event);
    });

    overlay.addEventListener('touchstart', function (event) {
        textElementClickHandler(textElement, event);
    });
}

function textElementClickHandler(textElement, event) {
    console.log('Text element clicked:', textElement);
    if (currentSelectedTextElement !== textElement) {
        console.log('Switching selected text element');
        removeExistingHighlight();
        currentSelectedTextElement = textElement;
        highlightTextElement(currentSelectedTextElement);
    }
    event.stopPropagation();
    // Additional logic for font application can be added here.
}
// Function to apply font to the selected text
function applyFontToSelectedText(fontFamily) {
    if (currentSelectedTextElement) {
        currentSelectedTextElement.style.fontFamily = fontFamily; // Apply font to the currentSelectedTextElement
    } else {
        console.log("No text element is selected.");
    }
}
// CSS for user experience enhancements
const style = document.createElement("style");
style.innerHTML = `
.text-interactive { cursor: pointer; }
    .editor-container { max-width: 100%; overflow-x: auto; }
    .highlighted-font { background-color: #e0e0e0; } 
    .font-card { transition: all 0.3s; }
    .selected-font { border: 2px solid #FFD700; box-shadow: 0 0 10px #FFD700; }
    .color-option { width: 30px; height: 30px; margin: 5px; border: 1px solid transparent; cursor: pointer; display: inline-block; }
    .selected-color { border: 1px solid #FFD700; box-shadow: 0 0 10px #FFD700; }
    .selected-text-element { border: 2px solid orange; }
    #font-search-bar { width: 100%; padding: 10px; margin-bottom: 10px; }
    .font-size-control { margin-top: 10px; }
`;
document.head.appendChild(style);





//video
// File: drawFunctions.js

/**
 * Renders the "Add Video" button.
 * Purpose: To allow users to add videos to their cards.
 * Why: Enhancing user experience by allowing multimedia integration.
 */
// Function to create "Add Video" button based on productData and page
// Function to create video upload and preview box


// Function to create "Add Video" button
function createAddVideoButton(page, configForProduct, configForPage, productData) {
    if (!configForPage) {
        console.error("configForPage is undefined or null");
        return; // Exit the function if configForPage is not available
    }

    if (configForPage.user_video) {
        // Create and configure "Add Video" button
        const addVideoButton = document.createElement("button");
        addVideoButton.id = "addVideoButton";
        addVideoButton.className = "add-video-btn";
        addVideoButton.innerText = "📹 Add Video to Your Card";

        // Append button to background container
        const backgroundContainer = document.getElementById("add_video");
        if (backgroundContainer) {
            backgroundContainer.appendChild(addVideoButton);
        }

        // Event listener to scroll and show video upload box
        addVideoButton.addEventListener("click", function () {
            const innerLeft = document.getElementById("inside_left-container");
            if (innerLeft && innerLeft.getBoundingClientRect) {
                const position = innerLeft.getBoundingClientRect();
                const canvasContainer = document.getElementById('canvas-container');
                if (canvasContainer && canvasContainer.scrollTo) {
                    const scrollTo = position.left - canvasContainer.getBoundingClientRect().left;
                    canvasContainer.scrollTo({
                        left: scrollTo,
                        behavior: 'smooth'
                    });
                }
            }

            // Create video upload and preview box
            showVideoModal();
        });
    }
}

function showVideoModal() {
    const modal = document.getElementById("videoModal");
    const closeBtn = document.querySelector(".close");
    const recordBtn = document.getElementById("recordVideo");
    const uploadBtn = document.getElementById("uploadVideo");
    const videoInput = document.getElementById("videoInput");
    const videoPreview = document.getElementById("videoPreview");
    const acceptBtn = document.getElementById("acceptVideo");

    // Show the modal
    modal.style.display = "block";

    // Close the modal
    closeBtn.onclick = function () {
        modal.style.display = "none";
    }

    // Handle video recording (Mocking it for now)
    recordBtn.onclick = function () {
        alert("Video Recording not implemented");
    }

    // Handle video upload
    uploadBtn.onclick = function () {
        videoInput.click();
    }

    videoInput.onchange = function () {
        const videoFile = videoInput.files[0];
        videoPreview.src = URL.createObjectURL(videoFile);
        videoPreview.style.display = "block";
        acceptBtn.style.display = "block";
    }

    // Handle video acceptance, trimming, cropping, and filters
    acceptBtn.onclick = function () {
        // TODO: Trim, Crop, and Apply Filters
        alert("Video Accepted! Implement trimming, cropping, and filters here.");
    }
}

function addVideoListener() {

    // File: eventListeners.js

}

/**
 * Renders a video placeholder in the inside_left section.
 * Purpose: To indicate where the video will be placed.
 * Why: Giving users a visual cue about video positioning.
 */
function drawVideoPlaceholder() {
    // Mock rendering logic
    console.log('Displaying video placeholder.');
}

/**
 * Shows a feedback modal after video addition.
 * Purpose: Gather user sentiments and feedback.
 * Why: Continuous improvement based on user feedback.
 */
function showFeedbackModal() {
    console.log('Showing feedback modal.');
}


/**
 * Handles files dropped into the video placeholder.
 * Purpose: Efficient and intuitive video uploads.
 * Why: Making the video upload process seamless and mobile-friendly.
 */
function handleDrop(files) {
    console.log('Files dropped:', files);
}

/**
 * Renders the drag and drop area.
 * Purpose: User-friendly video upload method.
 * Why: Drag-and-drop is an intuitive way to upload files.
 */
function renderDropzone() {
    console.log('Rendering dropzone for video uploads.');
}


/**
 * Previews the uploaded video.
 * Purpose: Allow users to review their videos.
 * Why: Ensuring users are satisfied with their video choice before addition.
 */
function previewVideo(videoFile) {
    console.log('Previewing video:', videoFile);
}

/**
 * Edits the uploaded video (mock function).
 * Purpose: Allow users to trim or add effects to their videos.
 * Why: Customization and ensuring the video fits well within the card.
 */
function editVideo(videoFile) {
    console.log('Editing video:', videoFile);
}


/**
 * Compresses the video.
 * Purpose: Reducing video size for efficient storage and faster uploads.
 * Why: Optimal user experience in video uploads and playback.
 */
function compressVideo(inputPath, outputPath) {
    console.log('Compressing video from', inputPath, 'to', outputPath);
}


//lamba
/**
 * AWS Lambda function for video processing.
 * Purpose: Scalable serverless video processing.
 * Why: Efficiently handling potentially large video files without server overhead.
 */
//exports.handler = async (event) => {
//  console.log('Processing video with AWS Lambda.');
//};

//File: awsUtils.js

//javascript
//Copy code
/**
 * Generates a pre-signed URL for accessing a video from S3.
 * Purpose: Secure, temporary access to private videos.
 * Why: Ensuring video access is controlled and time-limited.
 */
function getPresignedUrl(videoKey) {
    console.log('Generating pre-signed URL for video:', videoKey);
}